import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const __default__ = {
  name: 'promotionCodeList'
};
import PromotionFilterBlock from '../components/PromotionFilterBlock.vue';
import PromotionTableBlock from '../components/PromotionTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const filterSubmit = params => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(params);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(PromotionFilterBlock, {
        onFilterSubmit: filterSubmit
      }), _createVNode(PromotionTableBlock, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});